export enum DanceIntervalEnum {
  I_DONT_DANCE = 'I_DONT_DANCE',
  EVERY_DAY = 'EVERY_DAY',
  TWO_THREE_TIMES_A_WEEK = 'TWO_THREE_TIMES_A_WEEK',
  ONCE_A_WEEK = 'ONCE_A_WEEK',
  ONCE_A_MONTH = 'ONCE_A_MONTH',
}
